import {Main} from '../../components/main/main.tsx';
import FacebookLogin, {FacebookLoginClient, SuccessResponse} from '@greatsumini/react-facebook-login';
import {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '../../store/store.ts';
import {facebookLogin} from '../../store/slices/exchange_token_slice.ts';
import {redirect, useNavigate} from 'react-router-dom';
import {isFulfilled} from '@reduxjs/toolkit';
import {loginRedirectRoute} from '../../support/login_redirect_route.ts';
import {Hero} from '../../components/hero/hero.tsx';
import {Page} from '../../components/page/page.tsx';
import {Card} from '../../components/card/card.tsx';
import {FlexRow} from '../../components/utility/flex_row.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {__} from '../../support/lang/translations.ts';
import {Spacer} from '../../components/utility/spacer.tsx';
import {SocialButton, SocialMediaLoginType} from '../../components/button/social_button.tsx';

export function LoginWithFacebook() {
    useEffect(() => {
        FacebookLoginClient.init({appId: '__FACEBOOK_APP_ID__', version: 'v16.0'});
    }, []);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appConfig = useAppSelector((state) => state.appConfig.appconfig);
    const onLoginSuccess = async (response: SuccessResponse) => {
        const result = await dispatch(facebookLogin(response.accessToken));
        if (isFulfilled(result) && result.payload.facebookLogin) {
            navigate(loginRedirectRoute(result.payload.facebookLogin));
        }
        redirect('/');
    };

    return (
        <Main>
            <Hero
                url={appConfig?.loginscreen}
                urls={[appConfig?.sliderphoto1, appConfig?.sliderphoto2, appConfig?.sliderphoto3]}
            />
            <Page>
                <Card style={{width: '100%', maxWidth: 400, marginTop: '-4rem', zIndex: 998}}>
                    <FlexRow alignment={Alignment.Center}>
                        <h2 style={{textAlign: 'center'}}>{__('login.titles.facebook')}</h2>
                    </FlexRow>
                    <Spacer style={{height: '3rem'}} />
                    <FacebookLogin appId="__FACEBOOK_APP_ID__" onSuccess={onLoginSuccess} style={{display: 'none'}} />
                    <SocialButton
                        platform={SocialMediaLoginType.Facebook}
                        onClick={() => {
                            FacebookLoginClient.login(
                                (response) => {
                                    if (response.authResponse) {
                                        void onLoginSuccess(response.authResponse);
                                    }
                                },
                                {
                                    scope: 'public_profile, email',
                                },
                            );
                        }}
                    >
                        {__('login.buttons.facebook')}
                    </SocialButton>
                </Card>
            </Page>
        </Main>
    );
}
